<template>
	<div class="flex w-full flex-col gap-2">
		<h2 class="text-3xl font-bold">{{ t('document.offlineMessage') }}</h2>
		<i18n-t
			tag="p"
			class="text-secondary-600 text-lg"
			keypath="document.ftniConnect.prompt"
		>
			<strong>{{ t('document.ftniConnect.wifi') }}</strong>
			<strong>{{ t('document.ftniConnect.hotspot') }}</strong>
		</i18n-t>
		<button
			type="button"
			class="mt-4 flex h-12 w-48 items-center justify-center gap-2 self-start rounded-lg border px-4 py-2"
			:class="{
				'border-green-500 text-green-500': connectStatus !== 'connecting',
				'bg-green-500/30 text-green-500': connectStatus === 'connecting',
			}"
			@click="connectAttempt()"
		>
			<template v-if="connectStatus === 'connecting'">
				{{ t('document.connecting') }}
				<LoadingSVG
					class="ml-2"
					variant="green"
				/>
			</template>
			<template v-else>{{ t('document.connect') }}</template>
		</button>
		<p
			v-if="attempted && connectStatus === 'error'"
			class="text-secondary-600 mt-4 flex items-center gap-2"
		>
			<ExclamationTriangleIcon class="h-6 w-6 text-orange-300" />
			<span>
				<strong>{{ t('document.ftniConnect.failureHeading') }}</strong>
				{{ t('document.ftniConnect.failureBody') }}
			</span>
		</p>
		<hr class="my-4 border-slate-200" />
	</div>
</template>

<script setup lang="ts">
import LoadingSVG from '@/components/common/LoadingSVG.vue'
import { usePresentationLocale } from '@/i18n'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'
import { ref } from 'vue'

const attempted = ref(false)
const connectStatus = defineModel<string>('connectStatus', { required: true })

const { t } = usePresentationLocale()
const emit = defineEmits(['connect'])

const connectAttempt = () => {
	attempted.value = true
	emit('connect')
}
</script>
